module.exports = __webpack_public_path__ + "static/media/printer.a6e0833e.jpg";